import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';

export interface GraphCardHeaderProps {
  primary: string;
  secondary?: string | null;
  /** Space before chart content; moon phase list can override for extra room. */
  mb?: number;
}

const GraphCardHeader: FC<GraphCardHeaderProps> = ({
  primary,
  secondary,
  mb = 4,
}) => (
  <Box
    display="flex"
    alignItems="baseline"
    flexWrap="wrap"
    columnGap={2}
    rowGap={1}
    mb={mb}
    data-testid="weather-forecast-graph-card-header"
  >
    <Box fontSize="20px" fontWeight="bold" color="black" lineHeight="1.2">
      {primary}
    </Box>
    {secondary ? (
      <Box fontSize="20px" fontWeight="bold" color="darkgrey" lineHeight="1.2">
        {secondary}
      </Box>
    ) : null}
  </Box>
);

export default GraphCardHeader;
